/**
 * Report Polling Configuration
 * Simple constants for polling behavior
 */

export const REPORT_POLLING_CONFIG = {
  /** Initial polling delay in milliseconds (5 seconds) */
  INITIAL_DELAY_MS: 5000,

  /** Maximum polling delay in milliseconds (30 seconds) */
  MAX_DELAY_MS: 30000,

  /** Maximum number of polls before stopping (~6 minutes total) */
  MAX_POLLS: 12,

  /** Backoff multiplier (delay = INITIAL_DELAY_MS * pollCount * BACKOFF_MULTIPLIER) */
  BACKOFF_MULTIPLIER: 1,
};

/**
 * Calculate polling delay with exponential backoff
 * @param {number} pollCount - Current poll attempt (0-indexed)
 * @returns {number} Delay in milliseconds
 */
export const getPollDelay = (pollCount) => {
  const { INITIAL_DELAY_MS, MAX_DELAY_MS, BACKOFF_MULTIPLIER } = REPORT_POLLING_CONFIG;
  const delay = INITIAL_DELAY_MS * (pollCount + 1) * BACKOFF_MULTIPLIER;
  return Math.min(delay, MAX_DELAY_MS);
};
